import {
    CHANGE_USER_FILTER_START,
    CHANGE_USER_FILTER_SUCCESS,
    CHANGE_USER_FILTER_ERROR
} from '../../../constants';
import { userManagement as query } from '../../../lib/graphql';

export const changeUsersFilter = (currentPage, searchList, userType) => {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: CHANGE_USER_FILTER_START,
            });

            const { data } = await client.query({
                query,
                variables: { currentPage, searchList, userType }
            });

            if (data?.userManagement?.status == 'success') {
                dispatch({
                    type: CHANGE_USER_FILTER_SUCCESS
                });
            }
        } catch (error) {
            dispatch({
                type: CHANGE_USER_FILTER_ERROR
            });
        }
    };
}